import { useState } from "react";
import { qualityOptions, storageTips } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function StorageGuide() {
  const [activeKey, setActiveKey] = useState(qualityOptions[1].key);
  const active = qualityOptions.find((item) => item.key === activeKey) ?? qualityOptions[0];

  return (
    <section id="storage" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="存储与画质"
          title="下载到手机之前，先选对清晰度"
          description="清晰度决定了画质与占用空间的平衡。切换下面的档位了解差异，再结合手机剩余空间，决定要缓存多少集、用什么清晰度。"
        />

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1fr] md:mt-12 md:gap-8">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
            <div className="inline-flex flex-wrap gap-1 rounded-full bg-background-100 p-1">
              {qualityOptions.map((option) => (
                <button
                  key={option.key}
                  type="button"
                  onClick={() => setActiveKey(option.key)}
                  className={`rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap transition-colors ${
                    activeKey === option.key
                      ? "bg-accent-500 text-foreground-950"
                      : "text-foreground-600 hover:text-foreground-950"
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>

            <div className="mt-5 flex items-baseline gap-3">
              <span className="font-heading text-3xl font-black text-foreground-950 md:text-4xl">
                {active.res}
              </span>
              <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
                单集 {active.size}
              </span>
            </div>

            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              {active.detail}
            </p>

            <div className="mt-5 rounded-lg bg-background-100 p-4">
              <p className="text-xs font-semibold text-foreground-500">更适合的场景</p>
              <p className="mt-1 text-sm font-medium text-foreground-800">{active.scene}</p>
            </div>

            <p className="mt-4 text-xs leading-relaxed text-foreground-500">
              以上占用为参考区间，会随剧集时长与编码方式变化，实际大小以应用内显示为准。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
              <span className="flex h-6 w-6 items-center justify-center">
                <i className="ri-smartphone-line text-xl text-primary-600"></i>
              </span>
              下载到手机要管好这几件事
            </h3>
            <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {storageTips.map((tip) => (
                <div key={tip.title} className="rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100">
                    <i className={`${tip.icon} text-lg text-primary-600`}></i>
                  </span>
                  <p className="mt-3 text-sm font-bold text-foreground-950">{tip.title}</p>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{tip.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-5 rounded-lg bg-primary-50 p-4">
              <p className="text-sm leading-relaxed text-foreground-700">
                <span className="font-semibold text-primary-800">小提醒：</span>
                如果既想追剧又不想占太多空间，可以高低清晰度搭配——重点剧情用高清缓存，次要剧情用标清，兼顾画质与容量。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}